import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import PropTypes from 'prop-types';

import LoginForm from './LoginForm';
import RSVPForm from './RSVPForm';
import './RSVPPage.css';

class RSVPPage extends React.Component {
  static propTypes = {
    profile: PropTypes.object,
    firebase: PropTypes.object.isRequired,
  };

  static defaultProps = {
    profile: null,
  };

  render() {
    const { firebase, profile } = this.props;

    return (
      <div id="rsvp-page" className="rsvp-page content-wrapper">
        <div className="content">
          <h3>RSVP</h3>
          {profile.isLoaded && !profile.isEmpty ?
            <RSVPForm /> :
            <LoginForm firebase={firebase} />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { firebase: { profile } } = state;
  return {
    profile,
  };
};

export default compose(
  firebaseConnect(),
  connect(mapStateToProps),
)(RSVPPage);



// WEBPACK FOOTER //
// ./src/components/RSVPPage/index.js